import './js';
import { createApp } from 'vue';

const modules = import.meta.globEager('./components/*.vue');
const components = {};

for (const path in modules) {
    const name = path
        .split('/')
        .pop()
        .replace(/\.\w+$/, '');

    components[name] = modules[path].default;
}

for (const el of document.getElementsByClassName('vue-app')) {
    createApp({
        template: el.innerHTML,
        components,
    }).mount(el);
}
